module.exports = __webpack_public_path__ + "27751b629e4a8b873ecefbde28d4f01a.pdf";